export default "/videos/86f36e60799ac8208d835003d4129500.mp4";